import styled from 'styled-components';

export const FAQWrapper = styled.div`
  /* position: relative;
  z-index: 2; */
`;
